// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3mUfu","inner":"Form_inner__2YYFx","range":"Form_range__3vwCw","name":"Form_name__2qJuE","actions":"Form_actions__32vbU"};